/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, December 2021
 * @format
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import CheckCard from './CheckCard';
import { NoChecks } from './Divider';
import classes from './CheckCard.module.css';
import CommonUtil from './utils';
import modeEnums from '../../../../enums/modeEnums';

const ChecksWithoutGroup = props => {
  const {
    checks,
    setSelectedCheck,
    selectedItem,
    storeInfo,
    onHandleSms,
    updateOrderStatus,
    deviceGroup,
    currentMode,
    viewGuestLocationOnMap,
    onOrderDelivered,
  } = props;

  return (
    <div className={classes.checkCardsWrapper}>
      {checks.length === 0 ? <NoChecks /> : (
        checks.map(check =>
          <CheckCard
            key={check.id}
            check={check}
            checkConfig={CommonUtil.getCheckConfig(
              check,
              currentMode,
              storeInfo,
              setSelectedCheck,
              onHandleSms,
              updateOrderStatus,
              viewGuestLocationOnMap,
              onOrderDelivered
            )}
            onSelectCheck={setSelectedCheck}
            isCheckSelected={selectedItem.id === check.id}
            deviceGroup={deviceGroup}
            currentMode={currentMode}
          />
        )
      )}
    </div>
  );
};

export default ChecksWithoutGroup;

ChecksWithoutGroup.propTypes = {
  checks: PropTypes.array,
  setSelectedCheck: PropTypes.func,
  selectedItem: PropTypes.object,
  storeInfo: PropTypes.object,
  onHandleSms: PropTypes.func,
  updateOrderStatus: PropTypes.func,
  deviceGroup: PropTypes.object,
  currentMode: PropTypes.string,
  viewGuestLocationOnMap: PropTypes.func,
  onOrderDelivered: PropTypes.func,
};

ChecksWithoutGroup.defaultProps = {
  checks: [],
  setSelectedCheck: () => { },
  selectedItem: {},
  storeInfo: {},
  onHandleSms: () => { },
  updateOrderStatus: () => { },
  deviceGroup: null,
  currentMode: modeEnums.TABLE_DELIVERY,
  viewGuestLocationOnMap: () => { },
  onOrderDelivered: () => { },
};
